module.exports = __webpack_public_path__ + "img/issue-icon6.17d0acf.png";